import useTranslation from '@/utils/hooks/translation/useTranslation';

// Components
import { Illustration } from '@/components/composite/Illustration';

// Image
import illustrationEn from './../../../../../public/images/illustrations/illustrations-empty-en.webp';
import illustrationEs from './../../../../../public/images/illustrations/illustrations-empty-es.webp';
import illustrationFr from './../../../../../public/images/illustrations/illustrations-empty-fr.webp';

const AlbumsSearchNoData = () => {
    const { t } = useTranslation();
    return (
        <main className="flex flex-1 flex-col items-center justify-center space-y-2 text-icoGray-500 dark:text-icoDarkMode-wolf">
            <Illustration src={{ en: illustrationEn, fr: illustrationFr, es: illustrationEs }} />
            <span>{t('content:search_no_data')}</span>
        </main>
    );
};

export default AlbumsSearchNoData;
